export default "__VITE_ASSET__DKdK7LXp__"